<template>
  <div>
    <section class="alert check">
      <article class="alertCont">
        <div class="inner">
          <pre>{{ msg }}</pre>
          <div class="flex">
            <ColorButton
              color="border"
              :width="120"
              :height="34"
              :fontSize="14"
              @click="printReceipt"
            >
              <template #title>영수증 출력</template>
            </ColorButton>
          </div>
          <article class="btn-area">
            <button
              ref="checkRef"
              class="btn purple"
              @mouseup="initModal"
              @keyup.enter="initModal"
            >
              확인
            </button>
          </article>
        </div>
      </article>
      <article class="alertBottom">
        <button class="btn closeBtn" @click="initModal">
          <span class="hidden">닫기</span>
        </button>
      </article>
    </section>
    <section class="dim">
      <slot name="dimarea"></slot>
    </section>
  </div>
</template>

<script>
import ColorButton from '@/components/button/ColorButton.vue';
import api from '@/api/modules/smartroPayment';
import { useModal } from '@/composables/useModal';

export default {
  components: {
    ColorButton,
  },

  setup() {
    const { msg, initModal, focusButton } = useModal();

    return {
      msg,
      initModal,
      focusButton,
    };
  },

  async mounted() {
    this.focusButton(this.$refs.checkRef);

    const query = this.$route.query;

    if (query?.result === 'true') {
      const params = {
        paymentId: query.paymentId,
        carNumber: query.carNumber,
      };

      const res = await api.getReceiptPaymentInfo(params);

      if (res.result) this.printReceipt(res.data);
    }
  },

  methods: {
    printReceipt(item) {
      this.initModal();

      const printTemplate = {
        category: 'payment',
        carNo: item.carNumber,
        parkingName: item.parkingName,
        useDate: item.approvalDate,
        amount: item.purchaseAmount,
        payType: 'card',
        approvalNumber: item.cardApprovalNo,
      };

      const urlParams = new URLSearchParams(printTemplate);

      window.open(`/receipt?${urlParams}`);
    },
  },
};
</script>
